import {
  BillingType,
  // BudgetItem,
  Contract,
  CostCenter,
  Currency,
  FinancialResource,
  Id,
  PaymentResource,
  Reason,
  Reference,
  ResponseDataPaginate,
  Service,
  Target,
  Timestamp
} from 'src/types'

export enum ResourcesActionTypes {
  ADD_RESOURCE = '@resources/ADD_RESOURCE',
  FINISH_LOADER = '@resources/FINISH_LOADER',
  GET_RESOURCES = '@resources/GET_RESOURCES',
  GET_RESOURCES_FAILURE = '@resources/GET_RESOURCES_FAILURE',
  GET_RESOURCES_SUCCESS = '@resources/GET_RESOURCES_SUCCESS',
  RELOAD_RESOURCES_PAGE = '@resources/RELOAD_RESOURCES_PAGE',
  RELOAD_RESOURCES_PAGE_FAILURE = '@resources/RELOAD_RESOURCES_PAGE_FAILURE',
  SET_RESOURCES = '@resources/SET_RESOURCES',
  SET_RESOURCES_FAILURE = '@resources/SET_RESOURCES_FAILURE',
  SET_RESOURCES_SUCCESS = '@resources/SET_RESOURCES_SUCCESS'
}

export type ResourcesAvailable = {
  billing_types: BillingType
  contracts: Contract
  cost_centers: CostCenter
  currencies: Currency
  financial_resources: FinancialResource
  payment_resources: PaymentResource
  reasons: Reason
  references: Reference
  services: Service
  targets: Target
}

export type ResourcesHttpData = ResponseDataPaginate & {
  [K in keyof ResourcesAvailable]: ResourcesAvailable[K][]
}

interface ResourcesStateBasic<T> {
  allowAll: boolean
  error: boolean
  lastUpdate: Timestamp
  list: T[]
  loading: boolean
  organization_id: Id
  page: number
  total_pages: number
  total_results: number
}

export type ResourcesState = {
  readonly [K in keyof ResourcesAvailable]: ResourcesStateBasic<
    ResourcesAvailable[K]
  >
}
